"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransactionState = void 0;
/** Enum of state possible for an action */
var TransactionState;
(function (TransactionState) {
    TransactionState["PENDING"] = "pending";
    TransactionState["CONFIRMED"] = "confirmed";
})(TransactionState || (exports.TransactionState = TransactionState = {}));
